<div class="host-inventory-panel">
  <div class="v4-layout-form">
    <div class="v4-layout-form-title">
      {{ "operate_sidebar_html_日期" | translate }}
      <!-- Date -->
    </div>
    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row justify-between">
          <nz-range-picker
            class="flex-1 mr-5"
            nzSize="large"
            [nzFormat]="nzFormat"
            [(ngModel)]="dateRange"
            (ngModelChange)="onChangeDate($event)"></nz-range-picker>
          <div class="extra">
            {{
              (nights > 1 ? "component.sidebar.plural.total_nights" : "component.sidebar.singular.total_nights")
                | translate
                  : {
                      nights: nights
                    }
            }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="v4-layout-form">
    <div class="v4-layout-form-title">{{ "word.house_type" | translate }}</div>
    <div class="v4-layout-field">
      <div class="v4-option-list">
        <div class="v4-option-item" *ngFor="let type of selectedRoomTypes()">
          <div class="v4-option">
            {{ type.label }}
            <span class="ml-1" (click)="onRemoveType(type.value)" class="remove-icon">
              <i nz-icon nzType="close" nzTheme="outline"></i>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="v4-layout-field">
      <div class="v4-layout-control">
        <div class="relative">
          <span class="cursor-pointer leading-[32px] relative text-primary"
            >+{{ "component.sidebar.btn.add_house_type" | translate }}</span
          >
          <div class="absolute top-0 z-10 v4-room-type-select-hide-trigger">
            <v4-room-types-select
              [ngModel]="selectedRoomTypeIds()"
              (onSelectValues)="onSelectRoomTypes($event)"></v4-room-types-select>
          </div>
        </div>

        <!-- <a
          nz-button
          nzType="link"
          nz-dropdown
          nzTrigger="click"
          [(nzVisible)]="pickerVisible"
          [nzBackdrop]="false"
          [nzDropdownMenu]="dropdown"
          [nzPlacement]="'bottomCenter'"
          >+{{ "component.sidebar.btn.add_house_type" | translate }}</a
        >
        <nz-dropdown-menu #dropdown="nzDropdownMenu">
          <host-types-picker
            [selectedTypes]="types"
            (cancel)="pickerVisible = false"
            (select)="onTypePickerSelected($event)"
          ></host-types-picker>
        </nz-dropdown-menu> -->
      </div>
    </div>
  </div>

  <footer class="bar-footer">
    <button nz-button nzSize="large" (click)="onClickCancel()">{{ "word.cancel" | translate }}</button>
    <button nz-button nzType="primary" nzSize="large" hostThrottleClick (throttleClick)="onClickSave()">
      {{ "component.sidebar.btn.sync_inventory" | translate }}
    </button>
  </footer>
</div>
